import { useState } from "react";

// Motion (crg-polish, 2026-09-02): prefers-reduced-motion читается один раз на модуле —
// стили инлайновые, media-query из них не сделать.
const REDUCED_MOTION = typeof window !== 'undefined' && typeof window.matchMedia === 'function'
  && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const D_ROWS = REDUCED_MOTION ? '0s' : '0.28s';
const D_FADE = REDUCED_MOTION ? '0s' : '0.18s';
const EASE = 'cubic-bezier(0.2, 0, 0, 1)';

// theme prop: 'light' (default, all existing callers) | 'dark' (Vivid dark mode)
// Backward-compat: all existing callers omit theme → 'light' → identical rendering.
// className (2026-09-02): необязательный класс на корневой div — CRG Deals вешает
// `crg-day`, остальные вызывающие ничего не передают.
export function GroupHeader({ icon, title, count, total, accentColor, defaultOpen, children, theme, className }) {
  const [open, setOpen] = useState(defaultOpen !== false);
  const fmt = a => { const n = parseFloat(a) || 0; return n.toLocaleString("en-US") + "$"; };
  const dark = theme === 'dark';

  // Dark-mode tokens (only applied when theme='dark')
  const headerBg = dark ? 'linear-gradient(135deg, #141820 0%, #11151C 100%)' : 'linear-gradient(135deg, #FAFBFF 0%, #FFFFFF 100%)';
  const headerBorder = dark ? '1px solid rgba(56,189,248,0.10)' : '1px solid rgba(99,102,241,0.12)';
  const headerColor = dark ? '#E8ECF2' : '#0F172A';
  const totalColor  = dark ? '#E8ECF2' : '#0F172A';
  const bodyBg      = dark ? '#11151C' : '#FFFFFF';

  return (
    <div className={className} style={{ marginBottom: 24, animation: "fadeUp 0.4s ease both" }}>
      <button aria-expanded={open} onClick={() => setOpen(!open)} style={{
        display: "flex", alignItems: "center", gap: 10, width: "100%",
        padding: "18px 24px", background: headerBg,
        border: headerBorder, borderRadius: open ? "16px 16px 0 0" : 16,
        cursor: "pointer", color: headerColor, fontSize: 16, fontWeight: 800,
        transition: `border-radius ${D_ROWS} ${EASE}, box-shadow 0.2s ease`,
        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
      }}
        onMouseEnter={e => { e.currentTarget.style.boxShadow = `0 4px 16px rgba(0,0,0,0.06), 0 0 20px ${accentColor}10`; }}
        onMouseLeave={e => { e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.04)"; }}
      >
        <span style={{ color: accentColor, display: "flex", fontSize: 18 }}>{icon}</span>
        <span style={{ color: accentColor }}>{title}</span>
        <span style={{ background: `linear-gradient(135deg, ${accentColor}, ${accentColor}CC)`, color: "#FFF", borderRadius: 20, padding: "3px 14px", fontSize: 13, fontWeight: 700, marginLeft: 4 }}>{count}</span>
        {total !== null && total !== undefined && <span style={{ marginLeft: "auto", fontFamily: "'JetBrains Mono',monospace", fontSize: 15, fontWeight: 800, color: totalColor, letterSpacing: -0.3 }}>{fmt(total)}</span>}
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ transform: open ? "rotate(180deg)" : "rotate(0)", transition: `transform ${D_ROWS} ${EASE}`, marginLeft: total !== null && total !== undefined ? 12 : "auto", flexShrink: 0 }}>
          <path d="M4 6l4 4 4-4" stroke="#94A3B8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
      {/* Сворачивание: grid-template-rows 1fr <-> 0fr (тот же приём, что Radar BroadcastsSection)
          вместо прежнего max-height 5000px -> 0: у max-height видимая высота стояла на месте
          ~3/4 длительности и схлопывалась за последние ~100 мс — владелец видел «рывок, fps 30».
          Внутренний div: min-height 0 + overflow hidden, иначе строка грида не сожмётся ниже
          контента; рамка/тень/скругление тела — на нём, чтобы клип шёл по ним. Дети остаются
          в DOM (как раньше). */}
      <div style={{
        display: "grid",
        gridTemplateRows: open ? "1fr" : "0fr",
        opacity: open ? 1 : 0,
        transition: `grid-template-rows ${D_ROWS} ${EASE}, opacity ${D_FADE} ease`,
      }}>
        <div style={{
          minHeight: 0,
          overflow: "hidden",
          background: bodyBg,
          border: headerBorder,
          borderTop: "none",
          borderRadius: "0 0 16px 16px",
          boxShadow: dark ? "0 8px 24px rgba(0,0,0,0.3), 0 2px 8px rgba(0,0,0,0.2)" : "0 8px 24px rgba(99,102,241,0.06), 0 2px 8px rgba(0,0,0,0.03)",
        }}>
          {children}
        </div>
      </div>
    </div>
  );
}
